import React from 'react';

interface SectionHeaderProps {
  title: string;
  description: string;
  eyebrow?: string;
}

const SectionHeader = ({ title, description, eyebrow }: SectionHeaderProps) => {
  return (
    <div className="text-center space-y-4 mb-16">
      {eyebrow && (
        <span className="inline-flex items-center rounded-full bg-primary/10 px-4 py-1.5 text-sm font-semibold text-primary">
          {eyebrow}
        </span>
      )}
      <h2 className="text-4xl font-bold text-neutral-dark">
        {title}
      </h2>
      <p className="text-lg text-neutral-600 max-w-2xl mx-auto">
        {description}
      </p>
    </div>
  );
};

export default SectionHeader;